
import { Inject, Options, Vue } from "vue-property-decorator";
import CalendarView from "@/shared/components/calendar-view/index.vue";
import { TrustAPI } from "@/shared/modules/trust-api";
import { AppInsights } from "@/trust-admin-app/appInsights";
import { EventEmitter } from "events";
import store from "@/trust-admin-app/store";
import { EventView, TimeEntryActivity, TimeEntryView, TrustTeamMemberView } from "@/shared/modules/typescript-trustapi-client/models";
import { EventInput, ViewApi } from "@fullcalendar/core";
import { eventTransform } from "@/shared/components/helpers";
import LoadingIndicator from "@/shared/components/loading-indicator/index.vue";
import { EventForm } from "@/trust-admin-app/components/add-event-modal/event-form";

@Options({
  components: {
    CalendarView,
    LoadingIndicator,
  }
})
export default class CalendarMain extends Vue {
  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Inject({ from: 'timeEntryActivity', default: [] })
  private timeEntryActivity!: TimeEntryActivity[];

  private ai = new AppInsights;

  private currentCalendarView: ViewApi = null as any;

  private loadingEvents = false;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  mounted(): void {
    window.scrollTo(0, 0);
    this.eventCtrl.on('reload-events-data', this.getEvents);
  }

  beforeUnmount(): void {
    this.eventCtrl.removeListener('reload-events-data', this.getEvents);
  }

  private eventData: EventInput[] = [];

  private async getEvents(): Promise<void> {
    try {
      this.loadingEvents = true;
      const resp: any = await this.apiService.CalendarApi?.apiV2CalendarGetEventsByTrustTeamMemberIdPost({
        trustTeamMemberId: this.selectedTrustTeamMember.id,
        startDate: new Date(this.currentCalendarView.activeStart),
        endDate: new Date(this.currentCalendarView.activeEnd),
        showMissingTime: true
      });
      // console.log(resp.data.data);
      this.eventData = [...eventTransform(resp.data.data)];
    } catch (error) {
      console.log(error);
      this.eventCtrl.emit('show-snackbar', 'error', error);
      this.ai.trackException('Error getting investigations: ' + error);
    } finally {
      this.loadingEvents = false;
    }
  }

  private addTime(): void {
    this.eventCtrl.emit('showAddEditEventModal', { eventTypeId: 1, trustTeamMemberId: this.selectedTrustTeamMember.id });
  }

  private addAppointment(): void {
    try {
      this.eventCtrl.emit('showAddEditEventModal', {
        eventTypeId: 1,
        activityType: this.timeEntryActivity.filter(x => x.id == 1)[0],
        trustTeamMemberId: this.selectedTrustTeamMember.id
      });
    } catch {
      this.eventCtrl.emit('showAddEditEventModal', {
        eventTypeId: 1,
        activityType: null,
        trustTeamMemberId: this.selectedTrustTeamMember.id
      });
    }
  }

  private async eventItemClicked(data: any): Promise<void> {
    const eventItem: EventView = data.event.extendedProps.eventItem;
    try {
      const resp: any = await this.apiService.TimeEntryApi?.apiV2TimeEntryGetTimeEntryByIdTimeEntryIdGet(eventItem.id);
      const timeEntry: TimeEntryView = resp.data.data as TimeEntryView;
      if (eventItem.isEditable) {
        const eventFormData: EventForm = {
          id: timeEntry.id,
          eventTypeId: timeEntry.timeEntryType?.id ?? null,
          leaveTypeId: timeEntry.leaveType?.id ?? null,
          startDateTime: timeEntry.startDateTime,
          endDateTime: timeEntry.endDateTime,
          notes: timeEntry.notes ?? null,
          activityType: timeEntry.timeEntryActivity ?? null,
          investigation: timeEntry.investigation ?? null,
          breakDuration: timeEntry.breakDuration ?? null,
          trustTeamMemberId: timeEntry.trustTeamMember?.id ?? null,
          description: timeEntry.description ?? null,
        };
        this.eventCtrl.emit('showAddEditEventModal', eventFormData);
      }
    } catch (err) {
      console.log(err);
    }
  }
  

  private uiDateTimeRangeChanged(view: ViewApi): void {
    this.currentCalendarView = view;
    this.getEvents();
  }

  get selectedTrustTeamMember(): TrustTeamMemberView {
    return store.getters.getSelectedTrustTeamMember;
  }

}